import React, { useRef, useEffect , useState} from 'react';
 import { Button } from 'primereact/button';
 import { Toast } from 'primereact/toast';
 
 


const StepsNavigation = (props) => {
    // const [activeIndex, setActiveIndex] = useState(0);
    const {activeIndex, setActiveIndex} = props;
    const toast = useRef(null);


    const onNext = (index) => {
        if (index === 0) {
             setActiveIndex(index + 1);
        }
        else if (index === 1) {
            setActiveIndex(index + 1);
            
        }
    }

    const onPrevious = (index) => {
        if (index === 1) {
             setActiveIndex(index - 1);
        }
        else if (index === 2) {
            setActiveIndex(index - 1);
        }
    }

    return (
      <> <Toast ref={toast} />
        <div className="row">
            <div className='col'>

                <div style={{ float: 'right', marginTop: '0.5rem' }}>
                    {activeIndex !== 0 && <Button  size="small"
                        disabled={activeIndex !== 0 ? false : true}
                        label="Back" icon="pi pi-arrow-left"
                        className="mr-3" onClick={() => onPrevious(activeIndex)}>
                    </Button>}
                    {activeIndex !== 2 && <Button  size="small"
                        // disabled={activeIndex !==  1}
                        label="Continue" icon="pi pi-arrow-right"
                        className="ml-3" onClick={() => onNext(activeIndex)}>
                    </Button>
                    }
                    {activeIndex === 2 &&
                        <Button size="small" label="Configure"   ></Button>
                    }
                </div>
            </div>
        </div>
        </> 
    );
}

export default StepsNavigation;
